export default __webpack_public_path__ + "static/media/level-3-bg.68e8fc01.png";